import { Auditable, Person, QueryParams, SortParams, Surgery, Tissue, TissueOfferStatus } from "..";

export interface TissueOffer extends Auditable {
    tissueId: number;
    surgeonId: number;
    surgeryId: number;
    tissueOfferStatusId: number;
    acceptedOn?: string;
    method: string;
    declineReason: string;
    tissue: Tissue;
    surgeon: Person;
    surgery?: Surgery;
    tissueOfferStatus: TissueOfferStatus;
}

export const DefaultTissueOfferQueryParams: QueryParams = {};

export const DefaultTissueOfferSortParams: SortParams = {
    orderBy: "createdOn",
    orderDesc: "false",
};
